import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./ReferenceCamera.css";
import { TEXT } from "./texts";
import { useRefScan } from "./useRefScan";
import { RefCard } from "./RefCard";
import { RefPanels } from "./RefPanels";

// شاشة الصورة المرجعية (تصميم Soft Card) — نفس الشاشة أينما التُقطت صورة الوجه.
export const ReferenceCamera = ({ lang = "ar", onClose, onConfirm }) => {
  const T = TEXT[lang] || TEXT.ar;
  const areaRef = useRef(null);
  const cardRef = useRef(null);
  const [cardSize, setCardSize] = useState(null);
  const scan = useRefScan(lang);

  useLayoutEffect(() => {
    const measure = () => {
      const a = areaRef.current; if (!a) return;
      const cs = getComputedStyle(a);
      const W = a.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      const H = a.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      const w = Math.floor(Math.min(W, (H * 350) / 430));
      if (w > 0) setCardSize({ w, h: Math.round((w * 430) / 350) });
    };
    let r2 = 0;
    const r1 = requestAnimationFrame(() => { r2 = requestAnimationFrame(measure); });
    const mq = window.matchMedia("(orientation: portrait)");
    const onFlip = () => requestAnimationFrame(() => requestAnimationFrame(measure));
    mq.addEventListener("change", onFlip);
    return () => { cancelAnimationFrame(r1); cancelAnimationFrame(r2); mq.removeEventListener("change", onFlip); };
  }, []);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  const cardStyle = cardSize ? { width: cardSize.w, height: cardSize.h, aspectRatio: "auto" } : undefined;
  const camNote = scan.cam === "starting" ? T.starting : scan.cam === "denied" ? T.denied : scan.cam === "unavailable" ? T.unavailable : null;

  return createPortal(
    <div className={"hc" + (scan.review ? " is-review" : "")} dir={T.dir} lang={lang} data-testid="reference-camera">
      <header className="hc-head">
        <button type="button" className="hc-close hc-neu" aria-label={T.close} onClick={onClose} data-testid="refcam-close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2B3440" strokeWidth="2.3" strokeLinecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      </header>
      <RefCard T={T} scan={scan} cardStyle={cardStyle} cardRef={cardRef} areaRef={areaRef} camNote={camNote} />
      {!scan.review && <p className="hc-look" data-testid="refcam-look">{T.look}</p>}
      <RefPanels T={T} lang={lang} scan={scan} onConfirm={onConfirm} />
      <div className="hc-flash" ref={scan.flashRef} aria-hidden="true" />
    </div>,
    document.body
  );
};
